import React from "react";
import { Button, Modal } from "react-bootstrap";

interface ConfirmationModalProps {
    show: boolean;
    text: string;
    confirmText?: string;
    cancelText?: string;
    onHide: () => void;
    onConfirm: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ show, text, confirmText = 'Ok', cancelText = 'Cancel', onHide, onConfirm }) => {
    return (
        <Modal size={'sm'} show={show} onHide={onHide} centered data-testid="confirmation-modal">
            <Modal.Body>{text}</Modal.Body>
            <Modal.Footer>
                <Button onClick={onConfirm} data-testid="confirmation-ok">
                    {confirmText}
                </Button>
                <Button variant="secondary" onClick={onHide} data-testid="confirmation-cancel">
                    {cancelText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationModal;